import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

export const Wrapper = styled('div')`
  position: relative;
  z-index: 1;
  > svg {
    display: block;
  }
`;

interface Props {
  hover: boolean;
}

export const Now = styled('rect')<Props>`
  opacity: ${({ hover }) => (hover ? 1 : 0)};
  transition: opacity 0.1s;
`;

export const Label = styled('div')<Props>`
  user-select: none;
  position: absolute;
  top: 0;
  left: -4px;
  right: -4px;
  opacity: ${({ hover }) => (hover ? 1 : 0)};
  overflow: ${({ hover }) => (hover ? 'visible' : 'hidden')};
  transition: opacity 0.3s;
  > div {
    position: absolute;
    bottom: 0;
    left: 0;
    min-width: fit-content;
    width: 100%;
    background: white;
    height: ${({ hover }) => (hover ? 50 : 0)}px;
    display: block;
    border-radius: 4px;
    padding: 0 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    > b {
      ${({ theme }) => theme.typography.xSmallStrong}
      color: ${({ theme }) => theme.color.brand01};
      ${media.mdDown`
        margin-bottom: -4px;
      `}
    }
    > span {
      display: block;
      ${({ theme }) => theme.typography.tiny}
      color: ${({ theme }) => theme.color.spaceGray}
    }
  }
`;
